<template>
  <v-select
    v-model="localeTimeZone"
    dense
    label="Выбор таймзоны"
    outlined
    :items="timeZones"
    hide-details
  />
</template>
<script>
import { getTimezoneOffset } from "date-fns-tz"

export default {
  name: "TimezonePicker",
  model: {
    prop: "timeZone",
    event: "getTimeZone"
  },
  props: ["timeZone"],
  data: () => ({
    localeTimeZone: '', // chosen timezone
    timeZones: [] // list timezones
  }),
  watch: {
    localeTimeZone () {
      this.$emit('getTimeZone', this.localeTimeZone)
    }
  },
  mounted () {
    this.localeTimeZone = this.getLocalTimezone()
    this.$emit('getTimeZone', this.localeTimeZone)
    this.timeZones = this.getTimezone()
  },
  methods: {
    getLocalTimezone () {
      return Intl.DateTimeFormat().resolvedOptions().timeZone
    },
    getTimezone () {
      // const timeZones = Intl.supportedValuesOf('timeZone')
      const intl = new Intl.Locale("ru-RU")
      const date = new Date()
      const tz = intl.timeZones.map((timeZone) => {
        const strTime = date.toLocaleString("ru-RU", { timeZone: `${timeZone}` })
        // console.log(timeZone, strTime)
        // console.log(intervalToDuration({ start: date, end: new Date(strTime) }))
        let timeOffset = (getTimezoneOffset(timeZone, new Date(date)) / 1000 / 60 / 60).toString()
        if (timeOffset.includes(".")) {
          const timeOffsets = timeOffset.split(".")
          if (timeOffsets[0].startsWith("-")) {
            if (timeOffsets[0].length === 2) { timeOffsets[0] = `-0${timeOffsets[0].replace("-", "")}` }
          } else {
            if (timeOffsets[0].length === 1) { timeOffsets[0] = `+0${timeOffsets[0]}` } else { timeOffsets[0] = `+${timeOffsets[0]}` }
          }

          if (timeOffsets[1].length === 1) { timeOffsets[1] = `0${timeOffsets[1]}` }
          timeOffset = `${timeOffsets[0]}:${timeOffsets[1]}`
        } else {
          if (timeOffset.startsWith("-")) {
            timeOffset = timeOffset.length === 2 ? `-0${timeOffset.replace("-", "")}:00` : `${timeOffset}:00`
          } else { timeOffset = timeOffset.length === 1 ? `+0${timeOffset}:00` : `+${timeOffset}:00` }
        }
        // console.log('timeOffset', timeOffset)
        // console.log(`(UTC ${timeOffset}) ${timeZone}`)
        return { text: `(UTC ${timeOffset}) ${timeZone}`, value: timeZone }
      })
      return tz
    },
  }
}
</script>

<style scoped>

</style>
